import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonImg
} from '@ionic/react'
import SimpleBar from 'simplebar-react'
import parse from 'html-react-parser'
import './styles.scss'

export const ChapterCard = (props) => {
  const { chapter, setTitle } = props

  if (!chapter) return null

  return (
    <div className='chapter-card' itemScope itemType='http://schema.org/Episode'>

      <meta itemProp='url' content={`https://yokradio.com/ver/${chapter.id || chapter.id_content}_${chapter.url_title}`} />

      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

      <figure itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
        <meta itemProp='contentUrl' content={chapter.photo_min} />
        <Link
          to={`/ver/${chapter.id || chapter.id_content}_${chapter.url_title}`}
          aria-label={`Ver ${chapter.title}`}
        >
          {chapter.photo_min &&
            <IonImg
              alt={`Portada del episodio ${chapter.title}`}
              src={chapter.photo_min}
            />}
          {chapter.miniature &&
            <IonImg
              alt={`Portada del episodio ${chapter.title}`}
              src={chapter.miniature}
            />}
        </Link>
      </figure>
      <figcaption>
        <SimpleBar autoHide={false} style={{ maxHeight: 185 }}>
          <div className='content'>
            <Link
              to={`/ver/${chapter.id || chapter.id_content}_${chapter.url_title}`}
              aria-label={`Ver ${chapter.title}`}
              className='title'
              itemProp='name'
            >
              {chapter.title}
            </Link>
            {chapter?.intro &&
              <p className='intro' itemProp='abstract'>
                {chapter.intro}
              </p>}
            {chapter?.intro_html &&
              <div className='intro html' itemProp='abstract'>
                {parse(chapter.intro_html)}
              </div>}
            {setTitle &&
              <Link
                to={`/${chapter.category_alias}/${chapter.id_product}_${chapter.product_url}/1`}
                className='program-title'
                aria-label={`Ver todos los episodios de ${chapter.product}`}
              >
                {chapter.product}
              </Link>}
          </div>
        </SimpleBar>
      </figcaption>
    </div>
  )
}
